import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import * as layout from '../layout'
import { Button, LinkAsButton, styles as S } from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'
import * as modalActions from '../../../../actions/modal'

type PreviewProps = {
  project: projectModel.Project
  markStepSeen: () => Promise<void>
}

export function Preview({ project, markStepSeen }: PreviewProps): React.ReactElement<PreviewProps> | null {
  const dispatch = Redux.useDispatch()
  const manager = project.manager || project.default_manager

  const [open, setIsOpen] = React.useState(true)

  if (manager === undefined) {
    return null
  }

  return (
    <layout.SimpleModal
      closable={true}
      open={open}
      onClose={handleDone}
      buttons={[
        {
          type: 'button',
          props: {
            onClick: openShareOverlay,
            children: t('See my coming soon page'),
          },
        },
        {
          type: 'linkAsButton',
          props: {
            kind: 'secondary',
            onClick: handleDone,
            children: t('Later'),
          },
        },
      ]}
    >
      <S.copy.S.regular>
        {t(
          'This preview shows how your page will look exactly to your visitors. You also now have a “Coming soon” version of this page to grow your fans list.',
        )}
      </S.copy.S.regular>
    </layout.SimpleModal>
  )

  function handleDone(): void {
    setIsOpen(false)
    markStepSeen()
  }

  function openShareOverlay(): void {
    dispatch(modalActions.toggleShareOverlay(true))
    handleDone()
  }
}
